import React, { useEffect, useState, useRef } from "react";
import { Container } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import Loader from "../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";
// import { decryptData } from "../Utils/Crypto"; // Utility not found, so commented out

// --- Add this function to robustly extract verification_id ---
function getVerificationId() {
  const params = new URLSearchParams(window.location.search);
  // Try normal way first
  let id = params.get("verification_id");
  if (id) return id;
  // Fallback: look for "?verification_id" as a key
  id = params.get("?verification_id");
  if (id) return id;
  // Fallback: try to extract manually from the raw query string
  const match = window.location.search.match(/verification_id=([^&]+)/);
  return match ? match[1] : null;
}

const SessionSuccess = () => {
  const [queryParameters] = useSearchParams();
  // const verification_id = searchParams.get("verification_id");
  const verification_id = getVerificationId();
  const facepayParam = queryParameters.get("facepay");
  const [loading, setLoading] = useState(true);
  const [statusData, setStatusData] = useState(null);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    if (!verification_id) {
      setLoading(false);
      setError("No verification ID provided.");
      return;
    }
    axios
      .post(
        "/api/v2/external/gateway/kycee/get/document/status/",
        { verification_id }
      )
      .then((response) => {
        setStatusData(response.data);
        setLoading(false);
        if (response.status === 200) {
          toast.success("Verified successfully!");
          console.log(response.data);
          const redirectUrl = response.data?.data?.redirect_url;
          // if (redirectUrl) {
          //   if (facepayParam && window.ReactNativeWebView) {
          //     // window.ReactNativeWebView.postMessage(
          //     //   JSON.stringify({
          //     //     type: "VERIFICATION_COMPLETED",
          //     //     url: redirectUrl
          //     //   })
          //     // );
          //     window.ReactNativeWebView.postMessage("VERIFICATION_COMPLETED");
          //   } else {
          //     setTimeout(() => {
          //       window.location.href = redirectUrl;
          //     }, 2000);
          //   }
          // }
          if (facepayParam) {
            console.log("going to send the message to webview")
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage("VERIFICATION_COMPLETED");
            }
          } else {
            setTimeout(() => {
              const redirectUrl = response?.data?.data?.redirect_url;
              window.location.replace(redirectUrl ? redirectUrl : "https://kycee.in/signup");
            }, 1000);
          }
        } else {
          const errorMsg = response.data?.message || response.data?.error || "Verification failed. Please try again.";
          setError(errorMsg);
          toast.error("Verification Failed!");
        }
      })
      .catch((error) => {
        setError(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Failed to fetch document status."
        );
        toast.error("Verification Failed!");
        setLoading(false);
      });
  }, [verification_id]);

  return (
    <div style={{
      minHeight: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "#f6f8fa"
    }}>
      {loading ? (
        <div className="loader" style={{ marginBottom: 32 }}>
          <Loader />
        </div>
      ) : error ? (
        <div className="no-match">
          <div className="text-center">
            <h1
              className="text-error"
              style={{
                textShadow: "none",
                lineHeight: "normal",
                fontSize: "4rem",
                fontWeight: 700,
                marginBottom: 16,
                color: "#b00020",
              }}
            >
              Your Verification has been Failed...
            </h1>
            {/* <p style={{ color: "#b00020", fontSize: 18, marginBottom: 32, maxWidth: 400, textAlign: "center", margin: "0 auto" }}>
              {error}
            </p> */}
          </div>
        </div>
      ) : (
        <>
          <div className="no-match">
            <div className="text-center">
              <h1
                className="text-error"
                style={{
                  textShadow: "none",
                  lineHeight: "normal",
                  fontSize: "4rem",
                }}
              >
                Your Verification has been completed...
              </h1>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SessionSuccess; 